module.exports = __webpack_public_path__ + "static/media/buffet5.74e45eae.jpg";